import { ErrorBoundary } from '@sentry/react'

const ErrorBoundarySettings = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    Couldn't load settings view. Something went wrong. Check
                    Sentry for logs
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default ErrorBoundarySettings
